import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  dropdown: {
    minWidth: 200,
    maxWidth: 300,
    position: 'relative',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      maxWidth: '100%',
    },
  },
  formControl: {
    margin: 0,
    width: '100%',
  },
  select: {
    height: 40,
    backgroundColor: '#F4F6F8',
    borderRadius: 8,
    fontSize: '14px',
    '& .MuiOutlinedInput-notchedOutline': {
      border: 'none',
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      border: 'none',
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      border: `1px solid ${theme.palette.primary.main}`,
    },
    '& .MuiSelect-select': {
      display: 'flex',
      alignItems: 'center',
      height: 40,
      boxSizing: 'border-box',
      padding: '8px 32px 8px 12px',
      fontSize: '14px',
      lineHeight: '24px',
    },
  },
}))

export default useStyles
